var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 34,
    viewBox: "0 0 124 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.548 33.657L103.352 30.4787L114.449 19.3991H0.20874V14.7827H114.449L103.352 3.68537L106.548 0.524856L123.114 17.0909L106.548 33.657Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArraw);
export default __webpack_public_path__ + "static/media/arraw.eab4f8233940dd1032456b8b3e1fa9be.svg";
export { ForwardRef as ReactComponent };